import React from 'react';
import PropTypes from 'prop-types';
import IconButton from './IconButton';
import Typography from './Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: '0px 5px',
  },
}));

const Paging = (props) => {
  const classes = useStyles();
  const {
    page = 0,
    setPage,
    maxPage = 0,
    maxPageView = 5,
    position = 'left', // left, right
    type = 'full', // simple, simple-withText, component
    withoutFirstLast = true,
    pageNumberComponent,
    children,
    color = 'blue', // green & blue
  } = props;

  if (maxPage === -1) {
    return null;
  }

  const getColor = (color) => {
    if (color === 'green') {
      return '#1ab7a7';
    } else {
      return '#0073d1';
    }
  };

  const PageNumber =
    pageNumberComponent ||
    (({ number, isActive, onClick }) => (
      <Typography
        variant="h6"
        type="bold"
        style={{
          margin: '0px 5px',
          cursor: isActive ? 'default' : 'pointer',
          color: isActive ? getColor(color) : '#bfbfbf',
        }}
        onClick={onClick}
      >
        {number + 1}
      </Typography>
    ));

  const side = Math.floor(maxPageView / 2);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: position === 'right' ? 'flex-end' : 'unset',
        alignItems: 'center',
      }}
    >
      {type === 'full' && !withoutFirstLast && (
        <Typography
          type="bold"
          variant="body1"
          style={{
            marginRight: 5,
            cursor: page !== 0 ? 'pointer' : 'default',
            color: page !== 0 ? getColor(color) : '#bfbfbf',
          }}
          onClick={() => page !== 0 && setPage(0)}
        >
          First
        </Typography>
      )}
      <IconButton
        icon="chevron-left"
        size="md"
        variant="raised"
        disabled={page === 0}
        onClick={() => setPage(page - 1 >= 0 ? page - 1 : 0)}
        className={classes.button}
        color={color}
      />
      {type === 'full' ? (
        [...Array(maxPage > maxPageView - 1 ? maxPageView : maxPage + 1).keys()].map((i) => {
          const number =
            side - page >= 0 || maxPageView > maxPage
              ? i
              : page + side > maxPage
              ? maxPage - side * 2 + i
              : page - side + i;
          return (
            <PageNumber
              key={number}
              number={number}
              isActive={number === page}
              onClick={() => number !== page && setPage(number)}
            />
          );
        })
      ) : type === 'simple-withText' ? (
        <Typography variant="body1" type="bold" color="#1ab7a7">
          {page + 1} of {maxPage + 1}
        </Typography>
      ) : type === 'component' ? (
        children
      ) : null}
      <IconButton
        icon="chevron-right"
        size="md"
        variant="raised"
        disabled={page === maxPage}
        onClick={() => setPage(page + 1 <= maxPage ? page + 1 : maxPage)}
        className={classes.button}
        color={color}
      />
      {type === 'full' && !withoutFirstLast && (
        <Typography
          type="bold"
          variant="body1"
          style={{
            marginLeft: 5,
            cursor: page !== maxPage ? 'pointer' : 'default',
            color: page !== maxPage ? getColor(color) : '#bfbfbf',
          }}
          onClick={() => page !== maxPage && setPage(maxPage)}
        >
          Last
        </Typography>
      )}
    </div>
  );
};

Paging.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func.isRequired,
  maxPage: PropTypes.number,
  position: PropTypes.oneOf(['left', 'right']),
  type: PropTypes.oneOf(['full', 'simple']),
};

export default Paging;
